import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { readConfObject } from '@jbrowse/core/configuration';
import { observer } from 'mobx-react';
import { chooseGlyphComponent, layOut, layOutFeature } from './util';
function Subfeatures(props) {
  var _a;
  var feature = props.feature,
    featureLayout = props.featureLayout,
    selected = props.selected;
  return React.createElement(React.Fragment, null, (_a = feature.get('subfeatures')) === null || _a === void 0 ? void 0 : _a.map(function (subfeature) {
    var subfeatureId = String(subfeature.id());
    var subfeatureLayout = featureLayout.getSubRecord(subfeatureId);
    if (!subfeatureLayout) {
      return null;
    }
    var _ref = subfeatureLayout.data || {},
      GlyphComponent = _ref.GlyphComponent;
    return React.createElement(GlyphComponent, _objectSpread({
      key: "glyph-".concat(subfeatureId)
    }, props, {
      feature: subfeature,
      featureLayout: subfeatureLayout,
      selected: selected
    }));
  }));
}
Subfeatures.layOut = function (_ref2) {
  var layout = _ref2.layout,
    feature = _ref2.feature,
    bpPerPx = _ref2.bpPerPx,
    reversed = _ref2.reversed,
    config = _ref2.config,
    extraGlyphs = _ref2.extraGlyphs;
  var _a;
  var subLayout = layOutFeature({
    layout: layout,
    feature: feature,
    bpPerPx: bpPerPx,
    reversed: reversed,
    config: config,
    extraGlyphs: extraGlyphs
  });
  var displayMode = readConfObject(config, 'displayMode');
  if (displayMode !== 'reducedRepresentation') {
    var topOffset = 0;
    (_a = feature.get('subfeatures')) === null || _a === void 0 ? void 0 : _a.forEach(function (subfeature) {
      var SubfeatureGlyphComponent = chooseGlyphComponent(subfeature, extraGlyphs);
      var subfeatureHeight = readConfObject(config, 'height', {
        feature: subfeature
      });
      var subSubLayout = (SubfeatureGlyphComponent.layOut || layOut)({
        layout: subLayout,
        feature: subfeature,
        bpPerPx: bpPerPx,
        reversed: reversed,
        config: config,
        extraGlyphs: extraGlyphs
      });
      subSubLayout.move(0, topOffset);
      topOffset += displayMode === 'collapse' ? 0 : (displayMode === 'compact' ? subfeatureHeight / 3 : subfeatureHeight) + 2;
    });
  }
  return subLayout;
};
export default observer(Subfeatures);